import { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Divider,
  Grid,
  Stack,
  Switch,
} from "@mui/material";

import { SwitchRow, Label } from "../index.styles";
import DraggableInputs from "../../../components/Draggableinput";

import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectProductAnalyzerSettings } from "../../../features/settings/settings.selector";
import { ITag } from "../../../features/settings/settings.types";
import TagMenu from "../ProductAnalyzer/TagMenu";
import { updateProductAnalyzerSettingsThunk } from "../../../features/settings/settings.thunk";

const LayoutSettings = () => {
  const dispatch = useAppDispatch();
  const productAnalyzerSettings = useAppSelector(selectProductAnalyzerSettings);
  const [tagMenuEl, setTagMenuEl] = useState<null | HTMLElement>(null);
  const [tagToEdit, setTagToEdit] = useState<null | ITag>(null);
  const isTagMenuOpened = Boolean(tagMenuEl);

  if (!productAnalyzerSettings) return null;

  return (
    <Grid
      container
      spacing="16px"
      justifyContent="center"
      sx={{
        overflowX: "visible",
        flexWrap: "wrap",
        "@media (max-width:319px)": {
          overflowX: "auto",
          flexWrap: "nowrap",
          justifyContent: "flex-start",
        },
      }}
    >
      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{
          minWidth: "auto",
          maxWidth:"560px",
          "@media (max-width:319px)": {
            minWidth: "320px",
          },
        }}
      >
        {/* <Divider>Tags</Divider>

        <Stack direction="row" gap="6px" marginTop="8px">
          {productAnalyzerSettings.tags.map((tag) => (
            <Button
              key={tag.id}
              id={`tag-button-${tag.id}`}
              variant="outlined"
              aria-controls={isTagMenuOpened ? "tag-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={isTagMenuOpened ? "true" : undefined}
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                setTagMenuEl(event.currentTarget);
                setTagToEdit(tag);
              }}
            >
              {tag.caption}
            </Button>
          ))}
          <Button
            variant="contained"
            id="tag-button"
            aria-controls={isTagMenuOpened ? "tag-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={isTagMenuOpened ? "true" : undefined}
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
              setTagMenuEl(event.currentTarget);
              setTagToEdit(null);
            }}
          >
            New Tag
          </Button>
        </Stack>

        <TagMenu
          open={isTagMenuOpened}
          anchorEl={tagMenuEl}
          tag={tagToEdit}
          onClose={() => setTagMenuEl(null)}
        />

        <Divider sx={{ pt: 2 }}>Panels</Divider> */}

        {/* <SwitchRow>
          <Label tooltip="Show/hide jump to panel buttons in mobile device and chrome extension.">
            Show Jump Buttons
          </Label>
          <Switch
            checked={productAnalyzerSettings.showJumpButtons}
            onChange={(_e, checked: boolean) => {
              dispatch(
                updateProductAnalyzerSettingsThunk({
                  showJumpButtons: checked,
                }),
              );
            }}
          />
        </SwitchRow> */}

        <Box paddingX={1} mb={1}>
          <Alert severity="info">
            Drag panel headings to customize their order. Turning a panel off
            removes it from the Product Analyzer view.
          </Alert>
        </Box>

        <Stack className="sas-panels-form" padding={1} spacing={1}>
          <DraggableInputs data={productAnalyzerSettings.panelOrder} />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default LayoutSettings;
